
























































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import {
  ChannelsToLock,
  ChannelToLock,
  LockParams,
  MyChannel,
  UserInfo
} from "@/services/apiService/api.types";
import { digitCount, scrollToPage } from "@/helpers/utils";
import apiService from "@/services/apiService/apiService";
import { AlertAction, AlertState, AlertType } from "@/components/alert/types";
import { Action, Getter, Mutation } from "vuex-class";
import { Namespace } from "@/store/types";
import SpatialNavigation from "spatial-navigation-js";
import { keyCodeFinder } from "@/services/keyCodeService/keyCodeService";
import { KeySet } from "@/services/keyCodeService/keyCode.types";
import "dayjs/plugin/isBetween";
import apiStorageInterface from "@/services/apiStorageInterface";
import {
  SettingsGetters,
  SettingsMutations
} from "@/components/settings/types";
import LockIcon from "@/assets/svg/svg-settings/LockIcon.vue";
import { LocaleSettingsSortAndLock } from "@/plugins/i18n/types";
import { defaultUserInfo } from "@/helpers/constants";

@Component({
  components: { LockIcon }
})
export default class SettingsChannelCard extends Vue {
  @Prop() channel!: MyChannel;
  @Prop() cardIndex!: number;
  @Prop() channelCount!: number;

  @Action(AlertAction.UpdateAlert, { namespace: Namespace.Alert })
  newAlert!: (ChannelChangeGetter: AlertState) => Promise<void>;

  @Mutation(SettingsMutations.setChannelCardCurrPos, {
    namespace: Namespace.Settings
  })
  setChannelCardCurrPos!: (pos?: number) => void;

  @Mutation(SettingsMutations.setChannelCardNewPos, {
    namespace: Namespace.Settings
  })
  setChannelCardNewPos!: (pos?: number) => void;

  @Getter(SettingsGetters.getEncodedPin, { namespace: Namespace.Settings })
  getEncodedPin!: string;

  @Getter(SettingsGetters.getChannelCardCurrPos, {
    namespace: Namespace.Settings
  })
  getChannelCardCurrPos?: number;

  showControls = false;
  focusedControl = 0;
  reorderIndicator = false;

  scrollFuncRef = scrollToPage;

  LocaleSettingsSortAndLock = LocaleSettingsSortAndLock;

  userInfo: UserInfo = defaultUserInfo;

  async mounted(): Promise<void> {
    if (this.cardIndex === 0) {
      SpatialNavigation.focus("#channel" + this.channel.id);
    }

    this.userInfo = await apiStorageInterface.fetchUserInfo();
  }

  get favIcon(): string {
    return require("/src/assets/svg/svg-home/12-fav.svg");
  }

  get lockIcon(): string {
    return require("/src/assets/svg/svg-settings/02-lock-icon.svg");
  }

  get lockIconPurple(): string {
    return require("/src/assets/svg/svg-settings/02-lock-icon-purple.svg");
  }

  get sortIcon(): string {
    return require("/src/assets/svg/svg-settings/08-sort-icon.svg");
  }

  get channelNum(): string {
    let channelNum = "";
    for (let i = 0; i < 3 - digitCount(this.channel?.id); i++) {
      channelNum += "0";
    }
    return channelNum + this.channel.id + ".";
  }

  get isChannelLocked(): boolean {
    return this.channel.parentalLock;
  }

  async handleFavourite(): Promise<void> {
    try {
      if (!this.channel?.isFavorite) {
        await apiService.setChannelAsFavourite(this.channel.id);
      }
      if (this.channel?.isFavorite) {
        await apiService.removeChannelAsFavourite(this.channel.id);
      }
      this.$emit("channelUpdate");
    } catch (err) {
      const alertInfo: AlertState = {
        show: true,
        message: err.message,
        alertType: AlertType.Danger
      };
      await this.newAlert(alertInfo);
    }
  }

  openControls(): void {
    if (!this.reorderIndicator) {
      this.showControls = true;
    }
  }

  handleCardControls(event: KeyboardEvent): void {
    SpatialNavigation.pause();
    switch (keyCodeFinder(event.keyCode)) {
      case KeySet.KEY_ENTER:
        if (!this.showControls) {
          if (this.reorderIndicator) {
            this.reorderIndicator = false;
            this.$emit("reorder");
            return;
          }
          this.openControls();
          return;
        }
        switch (this.focusedControl) {
          case 0:
            this.handleLock();
            break;
          case 1:
            this.reorderIndicator = true;
            this.showControls = false;
            break;
          case 2:
            this.handleFavourite();
            break;
        }
        break;
      case KeySet.KEY_RIGHT:
        if (this.focusedControl < 2) {
          this.focusedControl += 1;
        }
        if (!this.showControls) {
          // sending event for reordering of channels
          if (this.reorderIndicator) {
            this.setChannelCardCurrPos(this.cardIndex);
            this.setChannelCardNewPos(this.cardIndex + 1);
            SpatialNavigation.resume();
            return;
          }

          SpatialNavigation.resume();
          return;
        }
        break;
      case KeySet.KEY_LEFT:
        if (this.focusedControl > 0) {
          this.focusedControl -= 1;
        }
        if (!this.showControls) {
          if (this.reorderIndicator) {
            this.setChannelCardCurrPos(this.cardIndex);
            this.setChannelCardNewPos(this.cardIndex - 1);
            SpatialNavigation.resume();
            return;
          }
          SpatialNavigation.resume();
          if (this.cardIndex % 5 === 0) {
            SpatialNavigation.focus("#Settings");
            return;
          }
          SpatialNavigation.focus();
        }
        break;
      case KeySet.KEY_DOWN:
        if (this.reorderIndicator) {
          this.setChannelCardCurrPos(this.cardIndex);
          this.setChannelCardNewPos(this.cardIndex + 5);
          SpatialNavigation.resume();
          return;
        }

        SpatialNavigation.resume();
        break;
      case KeySet.KEY_UP:
        if (this.reorderIndicator) {
          this.setChannelCardCurrPos(this.cardIndex);
          this.setChannelCardNewPos(this.cardIndex - 5);
          SpatialNavigation.resume();
          return;
        }
        SpatialNavigation.resume();
        break;
      case KeySet.KEY_BACK:
        if (!this.showControls) {
          this.$router.back();
        }
        if (this.showControls) {
          this.showControls = false;
        }
        SpatialNavigation.resume();
        break;
      default:
        SpatialNavigation.resume();
        break;
    }
  }

  //if not channel from this card, return status quo, if it is invert current setting(lock/unlock)
  setLockStatus(channel: MyChannel): null | LockParams {
    if (channel.id !== this.channel.id) {
      return channel.parentalLock ? { time_to: null, time_from: null } : null;
    }

    return this.channel.parentalLock
      ? null
      : { time_to: null, time_from: null };
  }

  async handleLock(): Promise<void> {
    let lockList: ChannelsToLock = { channels: [] };
    const channelList = await apiStorageInterface.fetchCustomChannelList();

    lockList.channels = channelList.map((channel) => {
      const convertedObj: ChannelToLock = {
        id: channel.id,
        channelLock: this.setLockStatus(channel)
      };

      return convertedObj;
    });

    await apiService.setLockedChannelList(
      this.userInfo.id,
      lockList,
      this.getEncodedPin
    );
    this.$emit("channelUpdate");
  }

  handleUnfocus(): void {
    this.showControls = false;
    if (this.reorderIndicator) {
      //maintains focus on element being rearranged
      setTimeout(() => {
        SpatialNavigation.focus("#channel" + this.channel.id);
      });
    }
  }

  handleFocus(): void {
    if (this.reorderIndicator) {
      //TODO: ffs dont do this, change ASAP
      setTimeout(() => {
        this.scrollFuncRef("channel" + this.channel.id);
      }, 300);
    } else {
      this.scrollFuncRef("channel" + this.channel.id);
    }
  }
}
